import "./megaMenu.scss";
import DataDrivenMegaMenu from "./dataDrivenMegaMenu";
import { useCallback, useEffect, useMemo } from "react";
import debounce from "lodash.debounce";
import React from "react";
import { ITabSetCategory } from "../../interfaces/ITabSetCategory";

export interface IMegaMenuTemplateProps {
  megaMenuCategory?: unknown;
  categories?: ITabSetCategory[];
  mobile?: boolean;
  className?: string;
  child?: unknown;
  html?: string;
  defaultSortOrderSearch?: string;
}

function MegaMenuTemplate(props: IMegaMenuTemplateProps) {
  const handleWindowResize = useCallback(() => {
    const megaMenu =
      document.getElementById("mega-menu") ||
      (document.getElementsByClassName(
        "ink-and-toner-finder"
      )[0] as HTMLElement);

    const headerOffset = document.getElementsByClassName(
      "react-header-offset"
    )[0] as HTMLElement;

    if (megaMenu) {
      const megaMenuHeight =
        window.innerHeight - headerOffset.offsetHeight - 148;
      megaMenu.style.maxHeight = megaMenuHeight + "px";
    }
  }, []);

  const debouncedHandleWindowResize = useMemo(() => {
    handleWindowResize();

    return debounce(handleWindowResize, 50, {
      leading: false,
      trailing: true,
    });
  }, [handleWindowResize]);

  useEffect(() => {
    window.addEventListener("resize", debouncedHandleWindowResize);

    return () => {
      window.removeEventListener("resize", debouncedHandleWindowResize);
    };
  }, [debouncedHandleWindowResize]);

  useEffect(() => {
    const megaMenu =
      document.getElementById("mega-menu") ||
      document.getElementsByClassName("ink-and-toner-finder")[0];

    if (megaMenu) {
      megaMenu.scrollTop = 0;
      handleWindowResize();
    }
  }, [props.megaMenuCategory, props.categories, handleWindowResize]);

  useEffect(() => {
    if (typeof window.CustomEvent === "function" && props.megaMenuCategory) {
      document.dispatchEvent(
        new CustomEvent("megaMenuOpened", { detail: { opened: true } })
      );
    }

    return () => {
      document.dispatchEvent(
        new CustomEvent("megaMenuOpened", { detail: { opened: false } })
      );
    };
  }, [props.megaMenuCategory]);

  const sanitizeHtml = (html: string) => {
    html = html
      .replace("\r", " ")
      .replace("\n", " ")
      .replace(new RegExp(">[s]+<", "g"), "><")
      .trim();

    const pattern = new RegExp("sc=\\w{2}", "g");
    const matches = html.matchAll(pattern) as any;

    for (const match of matches) {
      if (
        html[match.index - 1] === "?" ||
        html[match.index - 1] === "&" ||
        html[match.index + 5] === "&"
      ) {
        html =
          html.substring(0, match.index + 3) +
          props.defaultSortOrderSearch +
          html.substring(match.index + 5);
      }
    }

    return html;
  };

  const className = `mega-menu ${
    props.mobile ? "mobile" : "desktop scroll-applied"
  } ${props.className}`;

  const useChild = !!props.child;

  return (
    <>
      {!useChild && props.html && (
        <div
          className={className + " custom"}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.html) }}
          id="mega-menu"
        ></div>
      )}
      {!props.html && !useChild && (
        <div className={className} id="mega-menu">
          {props.categories && (
            <DataDrivenMegaMenu categories={props.categories} />
          )}
        </div>
      )}
      {useChild && props.child}
    </>
  );
}

export default MegaMenuTemplate;
